import { create } from "zustand";
import { PredefinedSettingsSchedule, ProfileData, RecurrenceDayListsEnum, RecurrenceDaySelectionEnum } from "@/clients/ntas/profiles";

export interface ProfilesMap {
    [key: string]: string;
}

interface ProfilesStore {
    profileId: string;
    setProfileId: (profileId: string) => void;
    profile: ProfileData;
    setProfile: (profile: ProfileData) => void;
    profiles: ProfileData[];
    setProfiles: (profiles: ProfileData[]) => void;
    profilesMap: ProfilesMap;
    setProfilesMap: (profilesMap: ProfilesMap) => void;
}

/**
 * Store for managing profiles.
 */
export const useProfilesStore = create<ProfilesStore>((set) => ({
    profileId: "",
    setProfileId: (profileId: string) => set(() => ({ profileId })),
    profile: {},
    setProfile: (profile: ProfileData) => set(() => ({ profile })),
    profiles: [],
    setProfiles: (profiles: ProfileData[]) => set(() => ({ profiles })),
    profilesMap: {},
    setProfilesMap: (profilesMap: ProfilesMap) => set(() => ({ profilesMap })),
}));

export enum ScheduleTypeEnum {
    Recurring = "recurring",
    OneTime = "oneTime",
}

export interface Schedule {
    profileId: string;
    scheduleType: ScheduleTypeEnum;
    startDate: string;
    endDate: string;
    overrideRecurringEntry?: boolean;
    dayList?: RecurrenceDayListsEnum[];
    daySelection?: RecurrenceDaySelectionEnum;
}

interface ScheduleStore {
    schedule: PredefinedSettingsSchedule;
    setSchedule: (schedule: PredefinedSettingsSchedule) => void;
}

export const useScheduleStore = create<ScheduleStore>((set) => ({
    schedule: {
        defaultProfileId: "1",
        isActive: true,
        removeExpiredEntries: false,
        settingsScheduleEntry: [],
    },
    setSchedule: (schedule: PredefinedSettingsSchedule) => set(() => ({ schedule })),
}));
